import Typography from '@mui/material/Typography'
import React from 'react'

import Stack from '@mui/material/Stack'
import { LinkingItem } from '../../Linking.types'
import Checkbox from '../../../../shared/components/Checkbox/Checkbox'

export type LinkableItemsModalListItemProps = {
    item: LinkingItem
    parentGroupName?: string
    childrenGroupName?: string
    isLastItem?: boolean
    checkIfSelected: (item: LinkingItem) => boolean
    onSelect: (item: LinkingItem, selected: boolean) => void
}

const LinkableItemsModalListItem = ({
    item,
    isLastItem,
    checkIfSelected,
    onSelect,
    childrenGroupName,
    parentGroupName,
}: LinkableItemsModalListItemProps) => {
    const hasChildren = !!item?.children?.length

    const selected = checkIfSelected(item)
    const handleSelect = () => onSelect(item, selected)

    return (
        <Stack
            direction="column"
            {...(hasChildren &&
                !isLastItem && {
                    borderBottom: '1px solid',
                    borderColor: 'figma.grayscale.stroke',
                })}
        >
            <Stack direction="column" gap={1}>
                {hasChildren && !!parentGroupName && <Typography variant="18x500">{parentGroupName}</Typography>}
                <Checkbox checked={selected} onCheck={handleSelect} label={item.name} />
            </Stack>
            {hasChildren && (
                <Stack direction="column" gap={1} mx={3} py={2}>
                    {!!childrenGroupName && <Typography variant="16x500">{childrenGroupName}</Typography>}
                    <Stack direction="column" gap={1.5}>
                        {item.children.map((child) => {
                            return (
                                <LinkableItemsModalListItem
                                    key={child._id}
                                    item={child}
                                    checkIfSelected={checkIfSelected}
                                    onSelect={onSelect}
                                    parentGroupName={parentGroupName}
                                    childrenGroupName={childrenGroupName}
                                />
                            )
                        })}
                    </Stack>
                </Stack>
            )}
        </Stack>
    )
}

export default LinkableItemsModalListItem
